import React from 'react';
import PropTypes from 'prop-types';
import './DelayTypeCard.scss';

DelayTypeCard.propTypes = {
  /** text to display on the card */
  text: PropTypes.string,
  /** delay_type to send to backend */
  delayType: PropTypes.string,
  iconSrc: PropTypes.string,
  onSelect: PropTypes.func,
};

export default function DelayTypeCard(props) {
  const { text, delayType, iconSrc, onSelect } = props;
  return (
    <div className="delay-type-card" key={delayType} onClick={ () => { onSelect && onSelect(delayType, text, iconSrc); }}>
      <img className="delay-type-card__icon" src={iconSrc} alt={text}/>
      <span className="delay-type-card__text">{text}</span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/DelayTypeCard/index.js